export const BALANCE_QUERY_KEY = "balance";
export const PROFILE_QUERY_KEY = "profile";
export const REIMBURSEMENT_TYPE_QUERY_KEY = "reimbursement_type";
export const ACHIEVEMENT_QUERY_TYPE = "achievement";
export const NOTIFICATION_QUERY_TYPE = "notificaton";
